import React, {useEffect, useRef} from 'react';
import {useDispatch} from 'react-redux';
import {
  cancelMultimedia,
  deleteMultimedia,
  scrolledToMultimedia,
} from 'shared/portfolio/actions/multimedia';
import PortfolioFormFooter from 'src/components/PortfolioFormFooter';
import FormCard from '../form-card';
import MultimediaFormInputs from './multimedia-form-inputs';
import MultimediaFormWrapper, {Multimedia} from './multimedia-form-wrapper';

interface Props {
  multimedia: Multimedia;
}

const MultimediaForm = ({multimedia}: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (multimedia.scrollTo) {
      setTimeout(() => {
        ref.current?.scrollIntoView({behavior: 'smooth'});
        dispatch(scrolledToMultimedia(multimedia._id));
      }, 550);
    }
  }, [dispatch, multimedia._id, multimedia.scrollTo]);

  return (
    <FormCard ref={ref} id={multimedia._id}>
      <MultimediaFormWrapper initialValues={multimedia}>
        <h4 className="portfolio-sections add-edit-header">
          {multimedia.new ? 'Add' : 'Edit'} Project
        </h4>
        <MultimediaFormInputs />
        <PortfolioFormFooter
          _id={multimedia._id}
          onCancel={() => dispatch(cancelMultimedia(multimedia))}
          onDelete={() => dispatch(deleteMultimedia(multimedia._id))}
          formName="portfolio multimedia multimedia-form"
        />
      </MultimediaFormWrapper>
    </FormCard>
  );
};

export default MultimediaForm;
